import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_84e14be8-c66b-4e50-b378-639bfe417cdf/artifacts/vn03bb90_297950681_1043688306290539_3612407571660205954_n.jpg';

export const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const navLinks = [
    { to: '/', label: 'Início', hash: false },
    { to: '/#promocoes', label: 'Promoções', hash: true },
    { to: '/pacotes', label: 'Pacotes', hash: false },
    { to: '/#cotacao', label: 'Peça sua Cotação', hash: true },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 sm:gap-3" data-testid="logo-link">
            <img 
              src={LOGO_URL} 
              alt="Rota Continental" 
              className="h-10 w-10 sm:h-12 sm:w-12 rounded-lg object-cover"
            />
            <span className="text-lg sm:text-xl font-bold text-slate-900">Rota Continental</span>
          </Link>
          
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`font-medium transition ${
                  !link.hash && isActive(link.to === '/' ? '/' : link.to)
                    ? 'text-[#00A8B5]'
                    : 'text-slate-700 hover:text-[#00A8B5]'
                }`}
                data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            className="md:hidden p-2 text-slate-700 hover:text-[#00A8B5] transition"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-slate-100 pb-4" data-testid="mobile-menu">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="block py-3 px-2 text-slate-700 hover:text-[#00A8B5] font-medium transition"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src={LOGO_URL} 
                alt="Rota Continental" 
                className="h-12 w-12 rounded-lg object-cover"
              />
              <span className="text-xl font-bold">Rota Continental</span>
            </div>
            <p className="text-slate-400 text-sm">
              Encontre as melhores promoções de passagens aéreas com milhas todos os dias.
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/" className="hover:text-white transition">Início</Link></li>
              <li><Link to="/#promocoes" className="hover:text-white transition">Promoções</Link></li>
              <li><Link to="/pacotes" className="hover:text-white transition">Pacotes</Link></li>
              <li><Link to="/#cotacao" className="hover:text-white transition">Peça sua Cotação</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Contato</h3>
            <p className="text-sm text-slate-400 mb-2">
              WhatsApp: +351 917 940 865
            </p>
            <p className="text-sm text-slate-400">
              Todos os direitos reservados &copy; {new Date().getFullYear()}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
